export default __webpack_public_path__ + "KaTeX_Caligraphic-Bold.7ce7636b90003f983253ab36004ed376.woff";